import type { FC } from 'react';

import { LucideCheck } from 'lucide-react';

import type { BaseField } from '@shared/api/findings/findings.types';
import { Button } from '@shared/components/ui';
import { toHumanReadableLabel } from '@shared/utils/label.utils';

interface FieldCardProps extends Pick<BaseField, 'field' | 'count' | 'selected'> {
  onToggle: (field: string) => void;
}

export const FieldCard: FC<FieldCardProps> = ({ field, count, selected, onToggle }) => (
  <Button
    type="button"
    aria-pressed={selected}
    variant="ghost"
    onClick={() => onToggle(field)}
    className={`h-9 w-full flex items-center justify-between px-2.5 py-0 box-border transition-colors border-0 shadow-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background ${
      selected ? 'bg-accent' : 'bg-transparent hover:bg-accent/50'
    } rounded-none`}
    data-testid="field-card-root"
  >
    <div className="flex items-center gap-1 relative shrink-0">
      <span className="text-[14px] font-normal whitespace-pre text-foreground" data-testid="field-card-label">
        {toHumanReadableLabel(field)}: <span className="text-muted-foreground">({count})</span>
      </span>
    </div>
    {selected && <LucideCheck color="var(--primary)" className="size-3.5" data-testid="field-card-check" />}
  </Button>
);
